import React from 'react';
import GamificationServices from '../services/GamificationServices';

const WeeklyStatsCard = ({ weeklyStats }) => {
  if (!weeklyStats) {
    return (
      <div className="gamification-card">
        <div className="card-header">
          <h3 className="card-title">
            <i className="las la-chart-line"></i>
            Esta Semana
          </h3>
        </div>
        <div className="loading-container" style={{ padding: '2rem' }}>
          <div className="loading-text">Carregando...</div>
        </div>
      </div>
    );
  }

  const { totals, comparison, daily_breakdown } = weeklyStats;
  
  const getChangeIcon = () => {
    if (!comparison || comparison.change === 0) return 'las la-minus';
    return comparison.change > 0 ? 'las la-arrow-up' : 'las la-arrow-down';
  };

  const getChangeColor = () => {
    if (!comparison || comparison.change === 0) return 'var(--text-muted)';
    return comparison.change > 0 ? 'var(--success)' : 'var(--danger)';
  };

  const getChangeText = () => {
    if (!comparison) return 'Sem dados anteriores';
    if (comparison.change === 0) return 'Sem alteração';
    
    const sign = comparison.change > 0 ? '+' : '';
    return `${sign}${GamificationServices.formatXP(comparison.change)} XP`;
  };

  const maxDailyXp = daily_breakdown ? 
    Math.max(...daily_breakdown.map(day => day.xp || 0)) : 1;

  return (
    <div className="gamification-card">
      <div className="card-header">
        <h3 className="card-title">
          <i className="las la-chart-line"></i>
          Esta Semana
        </h3>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          {weeklyStats.week_start} - {weeklyStats.week_end}
        </div>
      </div>

      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--primary)' }}>
            {GamificationServices.formatXP(totals?.xp || 0)}
          </div>
          <div className="stat-label">XP Semanal</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-value" style={{ color: 'var(--info)' }}>
            {totals?.activities || 0}
          </div>
          <div className="stat-label">Atividades</div>
        </div>
      </div>

      {/* Comparação com semana anterior */}
      {comparison && (
        <div style={{ 
          textAlign: 'center', 
          marginTop: '1rem', 
          padding: '0.75rem', 
          background: 'var(--surface)', 
          borderRadius: '8px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '0.5rem',
            fontSize: '0.9rem',
            fontWeight: '600',
            color: getChangeColor()
          }}>
            <i className={getChangeIcon()}></i>
            <span>{getChangeText()}</span>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '0.25rem' }}>
            vs. semana anterior
          </div>
        </div>
      )}

      {/* Gráfico semanal simplificado */}
      {daily_breakdown && daily_breakdown.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <div style={{ fontSize: '0.8rem', fontWeight: '600', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
            Atividade diária:
          </div>
          <div style={{ 
            display: 'flex', 
            alignItems: 'end', 
            gap: '2px', 
            height: '40px',
            padding: '0 0.25rem'
          }}>
            {daily_breakdown.map((day, index) => {
              const height = maxDailyXp > 0 ? (day.xp / maxDailyXp) * 100 : 0;
              const dayName = day.day_name?.substr(0, 3) || '';
              
              return (
                <div key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div
                    style={{
                      height: `${Math.max(height, 2)}%`,
                      width: '100%',
                      background: day.xp > 0 ? 'var(--primary)' : 'var(--gray-200)',
                      borderRadius: '2px 2px 0 0',
                      minHeight: '2px',
                      transition: 'all 0.3s ease'
                    }}
                    title={`${dayName}: ${day.xp} XP, ${day.activities} atividades`}
                  ></div>
                  <div style={{ 
                    fontSize: '0.6rem', 
                    color: 'var(--text-muted)', 
                    marginTop: '0.25rem',
                    textAlign: 'center'
                  }}>
                    {dayName}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Média diária */}
      {totals?.average_daily_xp && (
        <div style={{ 
          fontSize: '0.75rem', 
          color: 'var(--text-muted)', 
          textAlign: 'center',
          marginTop: '0.75rem',
          paddingTop: '0.75rem',
          borderTop: '1px solid var(--border-color)'
        }}>
          Média diária: {GamificationServices.formatXP(Math.round(totals.average_daily_xp))} XP
        </div>
      )}
    </div>
  );
};

export default WeeklyStatsCard;